export default __webpack_public_path__ + "static/media/geomine-total.d34ad00e.svg";